import { useState, useEffect } from "react";
import api from "../api";

function FeeStructure() {

  const [data, setData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const classOrder = [
    "Nursery", "LKG", "UKG",
    "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten"
  ];

  useEffect(() => {
    api.get("/fee-structure")
      .then(res => {
        const sorted = res.data.sort((a, b) =>
          classOrder.indexOf(a.class_name) - classOrder.indexOf(b.class_name)
        );
        setData(sorted);
      })
      .catch(err => console.log(err));
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...data];
    updated[index][field] = Math.max(0, Number(value) || 0);
    setData(updated);
  };

  const handleSave = () => {
    data.forEach(row => {
      api.post("/update-fee", row)
        .catch(err => console.log(err));
    });

    alert("Fee Structure Updated");
  };

  return (
    <div style={container}>
      <h2 style={{ marginBottom: "15px" }}>Fee Structure</h2>

      <table style={table}>
        <thead>
          <tr>
            <th style={th}>Class</th>
            <th style={th}>Tuition</th>
            <th style={th}>Exam</th>
            <th style={th}>New Adm</th>
            <th style={th}>Old Adm</th>
            <th style={th}>Annual (New)</th>
            <th style={th}>Annual (Old)</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, i) => {

            const annualNew =
              (Number(row.tuitionfee || 0) * 12) +
              Number(row.examfee || 0) +
              Number(row.newadmissionfee || 0);

            const annualOld =
              (Number(row.tuitionfee || 0) * 12) +
              Number(row.examfee || 0) +
              Number(row.oldadmissionfee || 0);

            return (
              <tr
                key={i}
                style={rowStyle}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.01)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
              >

                {/* CLASS */}
                <td style={{ ...td, fontWeight: "500" }}>
                  {row.class_name}
                </td>

                {/* TUITION */}
                <td style={td}>
                  <input
                    value={row.tuitionfee}
                    disabled={!isEditing}
                    style={isEditing ? input : inputDisabled}
                    onChange={(e) => handleChange(i, "tuitionfee", e.target.value)}
                  />
                </td>

                {/* EXAM */}
                <td style={td}>
                  <input
                    value={row.examfee}
                    disabled={!isEditing}
                    style={isEditing ? input : inputDisabled}
                    onChange={(e) => handleChange(i, "examfee", e.target.value)}
                  />
                </td>

                {/* NEW ADM */}
                <td style={td}>
                  <input
                    value={row.newadmissionfee}
                    disabled={!isEditing}
                    style={isEditing ? input : inputDisabled}
                    onChange={(e) => handleChange(i, "newadmissionfee", e.target.value)}
                  />
                </td>

                {/* OLD ADM */}
                <td style={td}>
                  <input
                    value={row.oldadmissionfee}
                    disabled={!isEditing}
                    style={isEditing ? input : inputDisabled}
                    onChange={(e) => handleChange(i, "oldadmissionfee", e.target.value)}
                  />
                </td>

                {/* ANNUAL NEW */}
                <td style={td}>
                  <input
                    value={annualNew}
                    readOnly
                    style={greenBox}
                  />
                </td>

                {/* ANNUAL OLD */}
                <td style={td}>
                  <input
                    value={annualOld}
                    readOnly
                    style={yellowBox}
                  />
                </td>

              </tr>
            );
          })}
        </tbody>
      </table>

      <div style={{ marginTop: "15px" }}>
        {!isEditing ? (
          <button onClick={() => setIsEditing(true)} style={editBtn}>
            Edit
          </button>
        ) : (
          <button
            onClick={() => {
              handleSave();
              setIsEditing(false);
            }}
            style={saveBtn}
          >
            Save Changes
          </button>
        )}
      </div>

    </div>
  );
}

export default FeeStructure;

//////////////////////////////////////////////////////
// 🎨 STYLES
//////////////////////////////////////////////////////

const container = {
  padding: "20px",
  background: "#f4f6f9",
  borderRadius: "10px"
};

const table = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: "0 8px"
};

const th = {
  textAlign: "left",
  padding: "10px 8px",
  fontSize: "12px",
  color: "#6b7280",
  fontWeight: "600"
};

const rowStyle = {
  background: "#ffffff",
  boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
  borderRadius: "8px",
  transition: "0.2s"
};

const td = {
  padding: "8px"
};

const input = {
  width: "90%",
  padding: "6px 8px",
  borderRadius: "6px",
  border: "1px solid #e5e7eb",
  fontSize: "13px",
  outline: "none"
};

const inputDisabled = {
  ...input,
  background: "#f9fafb"
};

const greenBox = {
  ...inputDisabled,
  background: "#dcfce7",
  fontWeight: "600",
  textAlign: "center"
};

const yellowBox = {
  ...inputDisabled,
  background: "#fef9c3",
  fontWeight: "600",
  textAlign: "center"
};

const editBtn = {
  padding: "8px 16px",
  background: "#f59e0b",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "13px"
};

const saveBtn = {
  padding: "8px 16px",
  background: "#16a34a",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "13px"
};